import * as React from "react"
import { cn } from "./lib/cn"

const glowColors = {
  brand: "shadow-[0_2px_8px_rgba(86,81,255,0.12),0_0_0_1px_rgba(86,81,255,0.06)]",
  blue: "shadow-[0_2px_8px_rgba(59,130,246,0.12),0_0_0_1px_rgba(59,130,246,0.06)]",
  emerald: "shadow-[0_2px_8px_rgba(16,185,129,0.12),0_0_0_1px_rgba(16,185,129,0.06)]",
  amber: "shadow-[0_2px_6px_rgba(245,158,11,0.10),0_0_0_1px_rgba(245,158,11,0.05)]",
  rose: "shadow-[0_2px_8px_rgba(244,63,94,0.12),0_0_0_1px_rgba(244,63,94,0.06)]",
  red: "shadow-[0_2px_8px_rgba(239,68,68,0.12),0_0_0_1px_rgba(239,68,68,0.06)]",
  gray: "shadow-[0_2px_8px_rgba(107,114,128,0.12),0_0_0_1px_rgba(107,114,128,0.06)]",
} as const

type GlowColor = keyof typeof glowColors

function GlowIconContainer({
  glow,
  className,
  ...props
}: React.ComponentProps<"div"> & { glow: GlowColor }) {
  return (
    <div
      data-slot="glow-icon-container"
      className={cn(
        "flex items-center justify-center rounded-xl bg-white",
        "h-11 w-11",
        "dark:bg-white/12",
        glowColors[glow],
        className
      )}
      {...props}
    />
  )
}

export { GlowIconContainer, glowColors, type GlowColor }
